import { render, staticRenderFns } from "./TaskDetailsModal.vue?vue&type=template&id=166ae568&"
import script from "./TaskDetailsModal.vue?vue&type=script&lang=js&"
export * from "./TaskDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports